import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { TotalProveiderMonth } from "../NetworkPortal/PayOut/helper";
import { getNetworkMenuId } from "../../Utils/types";
import CustomPagination from "../../common/CustomPagination";
import { payOutHeaderValue } from "../NetworkPortal/PayOut/AdditionalApptHeader";
import { GetInsurerPayoutCountsNetwork, getTotalClientData, GetTotalClientDataAction } from "../../redux/actions/InsBillAction";


export const TotalClient = ({
  setSwitchTab,
  searchFilter,
  providerDetail,
  setProviderDetail,
  setSearchFilter,
  downloadFile,
  setSelectAllFlag,
  setSelectAll,
  isLoadingExcel,
  header
}) => {
  const payoutReducer = useSelector((state) => state?.PayoutReducer);
  const globalReducer = useSelector((state) => state?.globalReducer);
  const insBillReducer = useSelector((state)=>state?.InsBillingPayout)
  const dispatch = useDispatch();

  
  useEffect(() => {
    dispatch(
        GetTotalClientDataAction({
        ...searchFilter,
        page: 1,
        rows: 10,
      })
    );
  }, []);

  return (
    <>
    <div className="table-responsive __custom__properties">
        <table className="table" >
          <thead>
            <tr className="avanishtbl">
              <th>
                <input
                  type="checkbox"
                  className="form-check-input"
                  checked={
                    insBillReducer?.getTotalClientData?.length ===
                    providerDetail?.length
                  }
                  onClick={(e) => {
                    if (e.target.checked) {
                      setProviderDetail(insBillReducer?.getTotalClientData);
                      setSelectAllFlag(true);
                    } else {
                      setSelectAll(false);
                      setProviderDetail([]);
                      setSelectAllFlag(false);
                    }
                  }}
                  readOnly
                />
              </th>
              <th style={{ minWidth: "260px" }}>Insurer Name </th>
              <th style={{ minWidth: "100px" }}>Month</th>
              <th style={{ minWidth: "10%", textAlign: "center" }}>
                {" "}
                Closed Cases
              </th>
              <th style={{ minWidth: "130px", textAlign: "center" }}>Insurer Amount</th>
              <th style={{ minWidth: "100px", textAlign: "center" }}>GST</th>
              <th style={{ minWidth:"100px",textAlign: "center" }}>Gross Amount</th>
              {header.map((ele) => {
                return <th style={{ minWidth: "150px", textAlign: "center" }}>{ele}</th>;
              })}
              <th style={{ textAlign: "center" }}>Status</th>
              <th style={{ textAlign: "center" }}>QC Approval</th>
              <th style={{minWidth: "100px", textAlign: "center" }}>Action</th>
            </tr>
          </thead>
           {insBillReducer?.getTotalClientData?.length !== 0 &&  <tbody>
            {insBillReducer?.getTotalClientData?.map((ele, index) => {
              return (
                <tr>
                  <td>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      checked={providerDetail.some((item) => ele === item)}
                      onClick={(e) => {
                        if (e.target.checked) {
                          setProviderDetail([...providerDetail, ele]);
                        } else {
                          setSelectAllFlag(false);
                          setSelectAll(false);
                          setProviderDetail(
                            providerDetail?.filter((item) => ele !== item)
                          );
                        }
                      }}
                      readOnly
                    />
                  </td>
                  <td >
                    <a
                      className="text-highlighted text-decoration"
                      style={{ cursor: "pointer", margin: "auto" }}
                      onClick={() => {
                        setSearchFilter({
                          ...searchFilter,
                          month: ele?.month,
                          clients:[{clientId:ele?.clientId,clientName:ele?.clientName}]
                        });
                        dispatch(
                          GetInsurerPayoutCountsNetwork({
                            ...searchFilter,
                            month: ele?.month,
                            clients:[{clientId:ele?.clientId}]
                          })
                        );
                        setSelectAll(false);
                        setSelectAllFlag(false);
                        setSwitchTab("totalApppointments");
                      }}
                    >
                      {ele?.clientName}
                    </a>
                  </td>
                  <td>{TotalProveiderMonth(ele?.year, ele?.month)}</td>
                  <td style={{ textAlign: "center" }}>
                    {ele?.totalAppointments?.toLocaleString('en-IN')}
                  </td>
                  <td style={{ textAlign: "center" }}>{ele?.grossAmount?.toLocaleString('en-IN')}</td>
                  <td style={{ textAlign: "center" }}>{ele?.gst?.toLocaleString('en-IN')}</td>
                  <td style={{ textAlign: "center" }}>{ele?.netAmount?.toLocaleString('en-IN')}</td>
                  {header.map((col, index) => {
                  return (
                    <td
                      key={index}
                      style={{textAlign:"center"}}
                    >
                       { ele[payOutHeaderValue[col]]}
                    </td>
                  );
                })}
                  <td style={{minWidht:"40%"}}>
                    <p
                      className={`status-style ${
                        ele?.paymentStatus === "Paid"
                              ? "approved"
                              : 
                                ele?.paymentStatus === "Removed"
                              ? "rejected"
                              : ele?.paymentStatus === "Pending At Finance"
                              ? "pendingAtFinance"
                              : ele?.paymentStatus === "Pending For Payment"
                              ? "pendingForpayment" : ele?.paymentStatus === "Partial Show"
                            ? "refundStatus" 
                              : "pending"
                      }`}
                    >
                      {" "}
                      {ele?.paymentStatus}
                    </p>
                  </td>
                  <td>
                  <button
                        className="btn search__btn action_export"
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#sendToQcModal"
                        disabled={
                          getNetworkMenuId()?.canEdit === false
                          ? true
                          : ele?.isInsurerPayoutStatus === false ||
                            ele?.paymentStatus !==
                              "Pending At Finance"
                          ? true
                          :ele?.billingRemoveFlag === "Y"? true: false
                        }
                        onClick={() => {
                          setProviderDetail([ele]);
                        }}
                      >
                      QC Approval &nbsp;
                        <i class="fa-solid fa-caret-right"></i>
                      </button>
                  </td>
                  <td style={{textAlign:"center"}}>
                      <button
                        className="btn search__btn action_export"
                        type="button"
                        disabled={isLoadingExcel || providerDetail?.length > 1}
                        onClick={() => {
                          downloadFile(ele);
                          setProviderDetail([...providerDetail, ele]);
                        }}
                      >
                        <i className="fa-solid fa-file-csv"></i>&nbsp;{" "}
                        {isLoadingExcel ? "Exporting..." : "Export"}
                      </button>
                  </td>
                </tr>
              );
            })}
          </tbody>}
         
        </table>
        {insBillReducer?.getTotalClientData?.length === 0 && <p className="noRecordFound">No Record Found</p>}
        <div className="d-flex justify-content-center mt-4">
          {globalReducer?.getTotalCount !== 0 && (
            <CustomPagination
              totalCount={globalReducer?.getTotalCount}
              perPageData={searchFilter?.rows}
              searchFilter={searchFilter}
              setSearchFilter={setSearchFilter}
              apiCall={GetTotalClientDataAction}
            />
          )}
        </div>
      </div>
      
    </>
  );
};
